import { Injectable } from '@angular/core'
import 'rxjs/add/operator/mergeMap'
import { Router } from '@angular/router'

@Injectable()
export class SessionService {

	private _user: any
	private _is_logged_in = false

	private _provider: any
	private _is_provider_logged_in = false

	private _userType: string

	constructor(private router: Router) {
		this.initSession(JSON.parse(localStorage.getItem('stus_user')))
		this.initSessionProvider(JSON.parse(localStorage.getItem('stus_provider')))
	}

	get user(): any {
		return this._user
	}

	get provider(): any {
		return this._provider
	}


	get access_token(): string {
		let access_token: string
		if (this._user && this._user.access_token) {
			access_token = this._user.access_token
		} else if (this._provider && this._provider.access_token) {
			access_token = this._provider.access_token
		} else {
			return ''
		}
		return access_token || ''
	}

	get is_logged_in(): boolean {
		return this._is_logged_in
	}

	get is_provider_logged_in(): boolean {
		return this._is_provider_logged_in
	}

	get userType(): string {
		return this._userType
	}

	set userType(userType: string) {
		this._userType = userType
	}

	logout() {
		this._is_logged_in = false
		this._user = undefined
		localStorage.removeItem('stus_user')
		localStorage.removeItem('stus_auth')
		this.router.navigate(['/login'])
	}

	logoutProvider() {
		this._is_provider_logged_in = false
		this._provider = undefined
		localStorage.removeItem('stus_provider')
		localStorage.removeItem('stus_auth')
		this.router.navigate(['/login'])
	}

	initSession(_user) {
		if (_user) {
			this._user = _user
			localStorage.setItem('stus_user', JSON.stringify(_user))
			localStorage.setItem('stus_auth', btoa('admin_app:4C0k8u3YVI3q'))
			this._userType = 'admin'
			this._is_logged_in = true
		}
	}

	// Provider
	initSessionProvider(provider) {
		if (provider) {
			this._provider = provider
			localStorage.setItem('stus_provider', JSON.stringify(provider))
			localStorage.setItem('stus_auth', btoa('provider_app:606Z0ha60W2n'))
			this._userType = 'provider'
			this._is_provider_logged_in = true
		}
	}
}



// WEBPACK FOOTER //
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/services/session.service.ts